const DOMAIN_NAME = 'managerialTree';
const MANAGERIAL_TREE_ROUTE_ID = 30;

const FORM_NAME = 'update-managerial-tree';

export { DOMAIN_NAME, MANAGERIAL_TREE_ROUTE_ID };
